import * as types from "@/store/mutation-types";

/* eslint-disable no-param-reassign */
/* eslint-disable no-shadow */

export const state = {
  initialized: false,
  signedIn: false,
  user: {
    idToken: null,
    profile: {},
  },
};

export const getters = {
  initialized: (state) => state.initialized,
  signedIn: (state) => state.signedIn,
  userId: (state) => state.user.profile.id,
  profile: (state) => state.user.profile,
  name: (state) => state.user.profile.fullName,
  idToken: (state) => state.user.idToken,
};

export const mutations = {
  [types.GOOGLE_USER_CHANGED](state, { user, idToken }) {
    if (user) {
      state.signedIn = true;
      state.user = {
        idToken: idToken,
        profile: {
          id: user.sub,
          emailAddress: user.email,
          fullName: user.name,
          imageUrl: user.picture,
        },
      };
    } else {
      state.user = {
        idToken: null,
        profile: {},
      };
    }
  },
  [types.GOOGLE_AUTH_INITIALIZED](state) {
    state.initialized = true;
  },
  [types.SIGN_OUT](state) {
    state.initialized = false;
    state.user = {
      idToken: null,
      profile: {},
    };
    state.signedIn = false;
  },
};

export const actions = {
  init({ commit, dispatch }) {
    const handleCredentialResponse = (response) => {
      const idToken = response.credential;
      const user = JSON.parse(window.atob(idToken.split(".")[1]));
      commit(types.GOOGLE_USER_CHANGED, { user, idToken: idToken });
    };

    window.onload = async function() {
      window.google.accounts.id.initialize({
        client_id: process.env.VUE_APP_CLIENT_ID,
        auto_select: true,
        callback: handleCredentialResponse,
      });

      await dispatch("renderSignInButton");

      window.google.accounts.id.prompt();
      commit(types.GOOGLE_AUTH_INITIALIZED);
    };
  },

  async renderSignInButton() {
    window.google.accounts.id.renderButton(
      document.getElementById("buttonDiv"),
      { text: "Sign in with Google", logo_alignment: "left" }
    );
  },

  async signOut({ commit, dispatch }) {
    await commit(types.SIGN_OUT);
    window.google.accounts.id.disableAutoSelect();
    dispatch("renderSignInButton");
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
